module.exports = __webpack_public_path__ + "img/right_icon.6a5fdcdb.png";